/* One Green Solution: header, reveal on scroll, hero word, counters. */
(function () {
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Header: shadow when scrolled, mobile menu.
  var head = document.querySelector('.ogs-head');
  if (head) {
    var onScroll = function () { head.classList.toggle('shrunk', window.scrollY > 60); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var burger = head.querySelector('.ogs-burger');
    if (burger) burger.addEventListener('click', function () {
      var open = head.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Count-up numbers.
  function count(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    var to = parseFloat(el.dataset.count), from = parseFloat(el.dataset.from || '0'),
      dec = parseInt(el.dataset.dec || '0', 10), suf = el.dataset.suf || '',
      sep = !!el.dataset.sep;
    var fmt = function (v) { return (sep ? Math.round(v).toLocaleString('en-US') : v.toFixed(dec)) + suf; };
    if (RM || isNaN(to)) return;
    var t0 = performance.now(), dur = 1300;
    var step = function (t) {
      var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(from + (to - from) * e);
      if (k < 1) requestAnimationFrame(step);
    };
    el.textContent = fmt(from);
    requestAnimationFrame(step);
  }

  // Reveal on scroll (content is visible without JS; see ogs.css).
  var items = document.querySelectorAll('.ogs .rv');
  if ('IntersectionObserver' in window && !RM) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        e.target.querySelectorAll('[data-count]').forEach(count);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -50px 0px' });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('in'); });
  }

  // "How it works" line fills as you scroll past it.
  var how = document.querySelector('.ogs-how');
  if (how && !RM) {
    var fill = function () {
      var r = how.getBoundingClientRect(), h = window.innerHeight;
      var p = Math.max(0, Math.min(1, (h - r.top - 80) / (r.height + h * 0.35)));
      how.style.setProperty('--p', p.toFixed(3));
    };
    window.addEventListener('scroll', fill, { passive: true });
    fill();
  } else if (how) {
    how.style.setProperty('--p', '1');
  }

  // Hero: the green word rotates (and the photo, when there is one per word).
  document.querySelectorAll('.ogs-hero').forEach(function (hero) {
    var words = hero.querySelectorAll('.ogs-rot span'),
      imgs = hero.querySelectorAll('.ogs-stage img'),
      badge = hero.querySelector('.ogs-badge[data-caps]'),
      capEl = badge ? badge.querySelector('span') : null,
      caps = badge ? badge.getAttribute('data-caps').split('|') : [],
      links = badge ? (badge.getAttribute('data-links') || '').split('|') : [];
    var later = hero.querySelectorAll('.ogs-stage img[data-src]');
    if (later.length) {
      var go = function () { setTimeout(function () { later.forEach(function (im) { if (im.dataset.srcset) im.srcset = im.dataset.srcset; im.src = im.dataset.src; im.removeAttribute('data-src'); }); }, 1200); };
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
    }
    if (words.length < 2 || RM) return;
    var i = 0;
    setInterval(function () {
      if (document.hidden) return;
      var prev = i;
      i = (i + 1) % words.length;
      words.forEach(function (w, k) {
        w.classList.remove('out');
        w.classList.toggle('on', k === i);
        if (k === prev) w.classList.add('out');
      });
      if (imgs.length === words.length) imgs.forEach(function (im, k) { im.classList.toggle('on', k === i); });
      if (capEl && caps.length === words.length) capEl.textContent = caps[i];
      if (badge && links.length === words.length && links[i]) badge.setAttribute('href', links[i]);
    }, 3200);
  });
})();

/* Product page: photos, options → variant, quantity, price. */
(function () {
  document.querySelectorAll('[data-ogs-product]').forEach(function (root) {
    var main = root.querySelector('[data-main]') || root.querySelector('.ogs-gal .main img');
    // Swap the big photo but keep Shopify's set of sizes, so phones still load a small file.
    function setMain(src, srcset) {
      if (!main || !src) return;
      if (srcset) { main.srcset = srcset; if (!main.sizes) main.sizes = '(max-width: 760px) 100vw, 600px'; } else main.removeAttribute('srcset');
      main.src = src;
    }
    // Scents: the "Scent notes" thumbnail shows the notes card over the photo; any photo thumbnail hides it.
    var notesPanel = root.querySelector('[data-notes-panel]');
    if (notesPanel) root.querySelectorAll('.ogs-gal .th button').forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.hasAttribute('data-notes');
        notesPanel.hidden = !on;
        var mainBox = root.querySelector('.ogs-gal .main'); if (mainBox) mainBox.classList.toggle('show-notes', on);
        if (on) root.querySelectorAll('.ogs-gal .th button').forEach(function (x) { x.classList.toggle('on', x === b); });
      });
    });
    root.querySelectorAll('.ogs-gal .th button').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.ogs-gal .th button').forEach(function (x) { x.classList.toggle('on', x === b); });
        if (main) setMain(b.dataset.src, b.dataset.srcset);
        var layer = root.querySelector('[data-ptag-layer]'), tpl = b.querySelector('template[data-ptags]');
        if (layer) layer.innerHTML = tpl ? tpl.innerHTML : '';
      });
    });

    var vj = root.querySelector('[data-variants]');
    var variants = vj ? JSON.parse(vj.textContent) : [];
    var fmtEl = root.querySelector('[data-money]');
    var fmt = fmtEl ? JSON.parse(fmtEl.textContent) : '${{amount}}';
    // All of Shopify's money formats ({{amount}}, {{amount_with_comma_separator}}, ...).
    function group(n, sep) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    function fmtNum(c, dec, th, ds) {
      var parts = (c / 100).toFixed(dec).split('.');
      return group(parts[0], th) + (dec ? ds + parts[1] : '');
    }
    var FORMATS = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'],
      amount_no_decimals_with_space_separator: [0, ' ', ','],
      amount_with_space_separator: [2, ' ', ','],
      amount_with_period_and_space_separator: [2, ' ', '.']
    };
    function money(c) {
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, key) {
        var f = FORMATS[key] || FORMATS.amount;
        return fmtNum(c, f[0], f[1], f[2]).replace(/([.,])00(?!\d)/, ''); /* $97.00 -> $97; $6.40 stays */
      });
    }

    var input = root.querySelector('[data-variant-input]'),
      priceEl = root.querySelector('[data-price]'),
      addBtn = root.querySelector('[data-add]'),
      qty = root.querySelector('[data-qty]'),
      sticky = root.querySelector('[data-sticky]'),
      stickyPrice = root.querySelector('[data-sticky-price]'),
      stickyAdd = root.querySelector('[data-sticky-add]');
    /* Phones: show the follow-along bar once the real button has scrolled off the top */
    if (sticky && addBtn) {
      var stickyTick = false, stickyShown = false;
      var stickyCheck = function () {
        stickyTick = false;
        var gone = addBtn.getBoundingClientRect().bottom < 0;
        if (gone === stickyShown) return;
        stickyShown = gone;
        sticky.classList.toggle('show', gone); sticky.setAttribute('aria-hidden', gone ? 'false' : 'true');
      };
      var stickyQueue = function () { if (!stickyTick) { stickyTick = true; requestAnimationFrame(stickyCheck); } };
      window.addEventListener('scroll', stickyQueue, { passive: true });
      window.addEventListener('resize', stickyQueue);
      stickyAdd.addEventListener('click', function () { if (!addBtn.disabled) addBtn.click(); });
    }
    var groups = root.querySelectorAll('.opts');

    /* Diffusers: "Add a scent" (one 50%-off refill, or the Traveler's 1 / 4 scent packs). Both items go to the cart together. */
    var sbox = root.querySelector('[data-scent-box]'), smode = 'none', sextra = 0, form = root.querySelector('[data-form]');
    function scentIds() {
      if (!sbox || smode === 'none') return [];
      var box = sbox.querySelector('[data-sels="' + smode + '"]');
      return box ? Array.prototype.map.call(box.querySelectorAll('[data-scent]'), function (x) { return x.value; }) : [];
    }
    if (sbox) {
      sbox.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dmode]'); if (!b) return;
        smode = b.dataset.dmode; sextra = parseInt(b.dataset.extra, 10) || 0;
        sbox.querySelectorAll('[data-dmode]').forEach(function (x) { x.classList.toggle('on', x === b); });
        sbox.querySelectorAll('[data-sels]').forEach(function (x) { x.hidden = x.dataset.sels !== smode; });
        update();
      });
      sbox.addEventListener('change', function (e) { if (e.target.matches('[data-scent]')) update(); });
      if (form) form.addEventListener('submit', function (e) {
        if (smode === 'none') return;
        var ids = scentIds();
        if (ids.some(function (x) { return !x; })) { e.preventDefault(); var first = sbox.querySelector('[data-sels="' + smode + '"] [data-scent]'); if (first) first.focus(); return; }
        e.preventDefault();
        var q = Math.max(1, parseInt(qty.value || '1', 10)), items = [{ id: parseInt(input.value, 10), quantity: q }], counts = {};
        ids.forEach(function (id) { counts[id] = (counts[id] || 0) + q; });
        Object.keys(counts).forEach(function (id) { items.push({ id: parseInt(id, 10), quantity: counts[id] }); });
        addBtn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); location.href = '/cart'; })
          .catch(function () { addBtn.disabled = false; form.submit(); });
      });
    }

    function selected() {
      return Array.prototype.map.call(groups, function (g) {
        var on = g.querySelector('button.on');
        return on ? on.dataset.value : null;
      });
    }
    function find(sel) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
    }
    function update() {
      var v = groups.length ? find(selected()) : variants[0];
      // Mark values that don't exist with the other choices.
      groups.forEach(function (g, gi) {
        g.querySelectorAll('button').forEach(function (b) {
          var sel = selected(); sel[gi] = b.dataset.value;
          var m = find(sel);
          b.classList.toggle('na', !m || !m.available);
        });
      });
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      input.value = v.id;
      var q = Math.max(1, parseInt(qty.value || '1', 10));
      priceEl.innerHTML = money(v.price) + (v.compare > v.price ? '<s>' + money(v.compare) + '</s>' : '');
      addBtn.disabled = !v.available;
      var missing = scentIds().filter(function (x) { return !x; }).length, total = (v.price + sextra) * q;
      addBtn.innerHTML = !v.available ? 'Sold out' : missing ? (missing > 1 ? 'Choose ' + missing + ' more scents' : 'Choose a scent') : 'Add to cart · <span data-total>' + money(total) + '</span>';
      if (stickyPrice) stickyPrice.textContent = money(total);
      if (stickyAdd) { stickyAdd.disabled = !v.available; stickyAdd.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (v.image) setMain(v.image, v.srcset);
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        g.querySelectorAll('button').forEach(function (x) { x.classList.toggle('on', x === b); });
        update();
      });
    });
    root.querySelectorAll('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, parseInt(qty.value || '1', 10) + parseInt(b.dataset.q, 10));
        update();
      });
    });
    if (qty) qty.addEventListener('change', update);
    /* Installation checkbox (systems): ticks the second value of the hidden Installation option */
    root.querySelectorAll('[data-inst]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var g = root.querySelector('.opts.inst'); if (!g) return;
        var bs = g.querySelectorAll('button'); var target = bs[cb.checked ? 1 : 0]; if (!target) return;
        bs.forEach(function (x) { x.classList.toggle('on', x === target); });
        update();
      });
    });
    if (variants.length) update();
  });
})();

/* Videos: play YouTube in a pop-up player on the page (the link still works without JS). */
(function () {
  var box, frame, lastFocus;
  function idFrom(href) {
    var m = /[?&]v=([\w-]{6,})/.exec(href) || /youtu\.be\/([\w-]{6,})/.exec(href);
    return m ? m[1] : null;
  }
  function close() {
    if (!box || box.hidden) return;
    box.hidden = true;
    frame.src = 'about:blank';
    document.documentElement.classList.remove('ogs-noscroll');
    if (lastFocus) lastFocus.focus();
  }
  function build() {
    box = document.createElement('div');
    box.className = 'ogs ogs-vbox';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Video');
    box.innerHTML = '<div class="in"><button type="button" class="x" aria-label="Close video">✕</button><div class="ratio"><iframe title="Video" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe></div></div>';
    document.body.appendChild(box);
    frame = box.querySelector('iframe');
    box.querySelector('.x').addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.ogs a[href*="youtube.com/watch"], .ogs a[href*="youtu.be/"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var id = idFrom(a.getAttribute('href'));
    if (!id) return;
    e.preventDefault();
    if (!box) build();
    lastFocus = a;
    var label = (a.querySelector('b, span') || a).textContent.trim();
    frame.title = label || 'Video';
    box.setAttribute('aria-label', label || 'Video');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    box.hidden = false;
    document.documentElement.classList.add('ogs-noscroll');
    box.querySelector('.x').focus();
  });
})();

/* Moving strips (Our work gallery, customer logos): images start "lazy" for page speed.
   Photos waiting off to the side of a moving strip would otherwise load only as they slide in
   and show blank for a moment, so load the whole strip as soon as it comes near the screen. */
(function () {
  var bands = document.querySelectorAll('.ogs-galband, .ogs-logoband');
  if (!bands.length) return;
  function loadAll(band) {
    band.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  if (!('IntersectionObserver' in window)) { bands.forEach(loadAll); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { loadAll(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '800px 0px' });
  bands.forEach(function (b) { io.observe(b); });
})();

/* App "coming soon" popup (footer badges, while the app isn't live) */
(function () {
  var box = document.getElementById('ogs-appsoon');
  if (!box) return;
  var form = box.querySelector('form'), email = box.querySelector('#ogs-as-email'),
      err = box.querySelector('.ogs-as-err'), done = box.querySelector('.ogs-as-done'),
      tags = box.querySelector('[data-astags]'), offers = box.querySelector('[data-asoffers]'), last = null;
  form.noValidate = true;
  function open(showDone) {
    last = document.activeElement; box.hidden = false;
    form.hidden = !!showDone; done.hidden = !showDone;
    setTimeout(function () { (showDone ? box.querySelector('.ogs-as-x') : email).focus(); }, 30);
  }
  function close() { box.hidden = true; if (last && last.focus) last.focus(); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-appsoon]')) { e.preventDefault(); open(false); }
    else if (e.target.closest('[data-asclose]')) close();
  });
  document.addEventListener('keydown', function (e) { if (!box.hidden && e.key === 'Escape') close(); });
  if (offers) offers.addEventListener('change', function () { tags.value = offers.checked ? 'app-waitlist, offers-yes' : 'app-waitlist'; });
  form.addEventListener('submit', function (e) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) { e.preventDefault(); err.hidden = false; email.focus(); }
  });
  /* after Shopify saves the sign-up it reloads the page with ?customer_posted=true */
  if (/[?&]customer_posted=true/.test(location.search)) open(true);
  else if (!err.hidden) open(false);
})();

/* Moving strips: pause as soon as the pointer is on them (more reliable than :hover alone,
   which Chrome on Mac may not update while content slides under a still cursor), and
   block native image dragging so a trackpad click always registers as a click. */
(function () {
  document.querySelectorAll('.ogs-galband, .ogs-logoband').forEach(function (band) {
    function hold() { band.classList.add('is-held'); }
    function release() { band.classList.remove('is-held'); }
    band.addEventListener('pointerenter', hold);
    band.addEventListener('pointerdown', hold);
    band.addEventListener('pointerleave', release);
    band.addEventListener('focusin', hold);
    band.addEventListener('focusout', release);
    band.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });
})();

/* Free samples popup: after the contact form, or when a visitor is about to leave */
(function () {
  var box = document.getElementById('ogs-sample');
  if (!box) return;
  var ls = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
             set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  var ss = { get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
             set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
             del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} } };
  var form = box.querySelector('form'), main = box.querySelector('.ogs-sp-main'), done = box.querySelector('.ogs-sp-done'),
      err = box.querySelector('[data-sp-err]'), count = box.querySelector('[data-sp-count]'),
      hidden = box.querySelector('[data-sp-scents]'), picks = [].slice.call(box.querySelectorAll('[data-sp-scent]')),
      days = parseInt(box.dataset.days, 10) || 30, tpl = box.dataset.template || '', last = null, opened = false;
  form.noValidate = true;

  function sent() { return !!ls.get('ogsSampleSent'); }
  function recentlySeen() { var t = parseInt(ls.get('ogsSampleSeen'), 10); return t && (Date.now() - t) < days * 864e5; }
  function otherPopupOpen() { var a = document.getElementById('ogs-appsoon'); return a && !a.hidden; }

  function open(mode) {
    if (opened || otherPopupOpen()) return;
    opened = true; last = document.activeElement; box.hidden = false;
    main.hidden = mode === 'done'; done.hidden = mode !== 'done';
    if (mode === 'after') {
      ['title', 'text'].forEach(function (k) { var el = box.querySelector('[data-sp-' + k + ']'); if (el && el.dataset.after) el.textContent = el.dataset.after; });
      /* they just sent us their details: fill them in and hide those fields; only ask for what's missing */
      try { var c = JSON.parse(ss.get('ogsContact') || '{}'), known = [];
        var okv = { name: function (v) { return v.trim() !== ''; },
                    phone: function (v) { return v.replace(/\D/g, '').length >= 10; },
                    email: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()); } };
        ['name', 'phone', 'email'].forEach(function (k) {
          var f = form.querySelector('[data-sp-' + k + ']'), v = c[k] || '';
          if (v) f.value = v;
          if (v && okv[k](v)) { f.closest('label').hidden = true; known.push(v); }
        });
        if (known.length) {
          var who = form.querySelector('[data-sp-who]');
          form.querySelector('[data-sp-whotext]').textContent = 'Sending to ' + known.join(' · ');
          who.hidden = false;
        }
      } catch (e) {}
    }
    if (mode !== 'done') ls.set('ogsSampleSeen', String(Date.now()));
    setTimeout(function () { var f = box.querySelector(mode === 'done' ? '.ogs-as-x' : '[data-sp-scent]'); if (f) f.focus(); }, 30);
  }
  function close() { box.hidden = true; if (last && last.focus) last.focus(); }
  box.addEventListener('click', function (e) { if (e.target.closest('[data-spclose]')) close(); });
  /* "Edit" next to "Sending to …": show the hidden name/phone/email fields again (attached once) */
  var editBtn = form.querySelector('[data-sp-edit]');
  if (editBtn) editBtn.addEventListener('click', function () {
    form.querySelectorAll('.ogs-sp-f label[hidden]').forEach(function (l) { l.hidden = false; });
    var who = form.querySelector('[data-sp-who]'); if (who) who.hidden = true;
  });
  document.addEventListener('keydown', function (e) { if (!box.hidden && e.key === 'Escape') close(); });

  /* pick exactly 3 scents */
  function sync() {
    var on = picks.filter(function (p) { return p.checked; });
    picks.forEach(function (p) { p.disabled = !p.checked && on.length >= 3; });
    count.textContent = on.length + ' of 3';
    hidden.value = on.map(function (p) { return p.value; }).join(', ');
    box.querySelectorAll('.ogs-sp-bag').forEach(function (b, i) {
      var p = on[i], im = p && p.parentNode.querySelector('img');
      b.classList.toggle('on', !!p);
      b.querySelector('i').style.backgroundImage = im ? 'url("' + (im.currentSrc || im.src) + '")' : '';
      b.title = p ? p.value : '';
    });
  }
  picks.forEach(function (p) { p.addEventListener('change', sync); });

  form.addEventListener('submit', function (e) {
    var bad = [];
    form.querySelectorAll('[required]').forEach(function (f) {
      var ok = f.value.trim() !== '';
      if (f.type === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.value.trim());
      if (f.type === 'tel') ok = f.value.replace(/\D/g, '').length >= 10;
      if (f.name === 'contact[ZIP]') ok = /^\d{5}(-\d{4})?$/.test(f.value.trim());
      f.classList.toggle('bad', !ok); if (!ok) bad.push(f);
    });
    var n = picks.filter(function (p) { return p.checked; }).length;
    var msg = n !== 3 ? 'Please pick 3 scents.' : bad.length ? 'Please fill in the highlighted fields (US address, 10-digit phone, 5-digit ZIP).' : '';
    if (msg) { e.preventDefault(); err.textContent = msg; err.hidden = false; (bad[0] || picks[0]).focus(); return; }
    ss.set('ogsSamplePending', '1');
  });

  /* remember what someone typed in the main contact form, to pre-fill the samples form */
  var cf = document.getElementById('OgsContactForm');
  if (cf) cf.addEventListener('submit', function () {
    var g = function (n) { var f = cf.querySelector('[name="contact[' + n + ']"]'); return f ? f.value : ''; };
    ss.set('ogsContact', JSON.stringify({ name: g('name'), phone: g('phone'), email: g('email') }));
  });

  /* back from Shopify after a form was sent */
  if (/[?&]contact_posted=true/.test(location.search)) {
    if (ss.get('ogsSamplePending')) { ss.del('ogsSamplePending'); ls.set('ogsSampleSent', '1'); open('done'); return; }
    if (box.dataset.afterContact === 'true' && !sent() && ss.get('ogsContact')) { setTimeout(function () { open('after'); }, 1500); return; }
  }
  if (box.dataset.exit !== 'true' || sent() || recentlySeen()) return;
  if (/^(cart|customers|password|gift_card|page\.contact)/.test(tpl) || /\/(cart|checkout|account)/.test(location.pathname)) return;

  var start = Date.now();
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && Date.now() - start > 8000) open('exit');
    });
  } else {
    var ready = false, delay = (parseInt(box.dataset.delay, 10) || 45) * 1000;
    var deep = function () { var h = document.documentElement; return (h.scrollTop + innerHeight) / h.scrollHeight >= 0.5; };
    var check = function () { if (ready && deep()) { window.removeEventListener('scroll', check); open('exit'); } };
    setTimeout(function () { ready = true; check(); }, delay);
    window.addEventListener('scroll', check, { passive: true });
  }
})();

/* Customer reels: play the Instagram reel in a popup on this page */
(function () {
  var pop = document.getElementById('ogs-reelpop');
  if (!pop) return;
  var frame = pop.querySelector('.ogs-rp-frame'), ig = pop.querySelector('.ogs-rp-ig'), last = null;
  function open(id, url, vid) {
    last = document.activeElement;
    var tpl = vid && document.getElementById('ogs-rv-' + vid);
    if (tpl) {
      frame.innerHTML = ''; frame.appendChild(tpl.content.cloneNode(true)); var yt = !!frame.querySelector('iframe[data-yt]'); frame.classList.toggle('is-video', !yt); pop.classList.toggle('is-yt', yt);
      var v = frame.querySelector('video'); if (v) { v.setAttribute('playsinline', ''); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    } else {
      frame.classList.remove('is-video'); pop.classList.remove('is-yt');
      frame.innerHTML = '<iframe src="https://www.instagram.com/reel/' + encodeURIComponent(id) + '/embed/" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="eager" title="Customer video"></iframe>';
    }
    ig.hidden = !id && !url;
    ig.href = url || ('https://www.instagram.com/reel/' + id + '/');
    pop.hidden = false; document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { pop.querySelector('.ogs-rp-x').focus(); }, 30);
  }
  function close() { pop.hidden = true; var v = frame.querySelector('video'); if (v) v.pause(); frame.innerHTML = ''; document.documentElement.style.overflow = ''; if (last && last.focus) last.focus(); }
  document.addEventListener('click', function (e) {
    var r = e.target.closest('[data-reel]');
    if (r && (r.dataset.reel || r.dataset.reelVid)) { e.preventDefault(); open(r.dataset.reel, r.dataset.reelUrl, r.dataset.reelVid); return; }
    if (e.target.closest('[data-rpclose]')) close();
  });
  document.addEventListener('keydown', function (e) { if (!pop.hidden && e.key === 'Escape') close(); });
})();

/* reels row arrows (when there are more than 5 videos) */
(function () {
  document.querySelectorAll('.ogs-reels-wrap.is-scroll').forEach(function (w) {
    var row = w.querySelector('.ogs-reels'), prev = w.querySelector('.prev'), next = w.querySelector('.next');
    function upd() { prev.disabled = row.scrollLeft < 8; next.disabled = row.scrollLeft + row.clientWidth > row.scrollWidth - 8; }
    w.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rlnav]'); if (!b) return;
      row.scrollBy({ left: (parseInt(b.dataset.rlnav, 10) || 1) * row.clientWidth * 0.8, behavior: 'smooth' });
    });
    row.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  });
})();

/* Keep keyboard focus inside whichever OGS pop-up is open (samples, app, customer video, YouTube video). */
(function () {
  var SEL = '#ogs-sample, #ogs-appsoon, #ogs-reelpop, .ogs-vbox';
  var FOC = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, video[controls], [tabindex]:not([tabindex="-1"])';
  function openBox() {
    var list = document.querySelectorAll(SEL);
    for (var i = list.length - 1; i >= 0; i--) if (!list[i].hidden) return list[i];
    return null;
  }
  function items(box) {
    return Array.prototype.filter.call(box.querySelectorAll(FOC), function (el) {
      return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var box = openBox(); if (!box) return;
    var f = items(box); if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || !box.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !box.contains(a))) { e.preventDefault(); first.focus(); }
  });
  /* if focus still slips out (e.g. tabbing out of a video frame), bring it back */
  document.addEventListener('focusin', function (e) {
    var box = openBox(); if (!box || box.contains(e.target)) return;
    var f = items(box); if (f.length) f[0].focus();
  });
})();

/* Product page on phones: Read more for long descriptions, and tap-to-open rows */
(function () {
  var desc = document.querySelector('[data-desc]'), btn = document.querySelector('[data-readmore]');
  var phone = window.matchMedia && window.matchMedia('(max-width:760px)');
  if (desc && btn && phone) {
    var fit = function () {
      if (btn.getAttribute('aria-expanded') === 'true') return;
      if (!phone.matches) { desc.classList.remove('clamp'); btn.hidden = true; return; }
      desc.classList.add('clamp');
      var long = desc.scrollHeight > desc.clientHeight + 8;
      btn.hidden = !long; if (!long) desc.classList.remove('clamp');
    };
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      desc.classList.toggle('clamp', !open); btn.textContent = open ? 'Show less' : 'Read more';
    });
    fit(); window.addEventListener('resize', fit); window.addEventListener('load', fit);
  }
  document.querySelectorAll('.ogs-acc-h').forEach(function (h) {
    h.addEventListener('click', function () {
      if (phone && !phone.matches) return;
      var box = h.parentNode, open = !box.classList.contains('open');
      box.classList.toggle('open', open); h.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();

/* Phones: "Show details" / "Show all" buttons on services pages */
(function () {
  /* Filter chips on product grids (by product tag) */
  document.querySelectorAll('[data-tagfilter]').forEach(function (nav) {
    var sec = nav.closest('section');
    if (!sec) return;
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-tag]');
      if (!b) return;
      nav.querySelectorAll('button').forEach(function (x) { x.classList.toggle('on', x === b); });
      var tag = b.getAttribute('data-tag'), n = 0;
      sec.querySelectorAll('.ogs-card[data-tags]').forEach(function (c) {
        var show = !tag || (c.getAttribute('data-tags') || '').indexOf('|' + tag + '|') > -1;
        c.hidden = !show;
        if (show) n++;
      });
      var cnt = sec.querySelector('[data-count]');
      if (cnt) cnt.textContent = n + ' product' + (n === 1 ? '' : 's');
    });
  });

  /* Estimators under the product photos: scent (diffusers), water flow (Cleone), clean air (Deluxe), whole-home (Super V).
     Config comes from the product metafield custom.estimator; same math as the mockup and the One Green Solution app. */
  document.querySelectorAll('[data-est]').forEach(function (box) {
    var cfg; try { cfg = JSON.parse(box.getAttribute('data-est')); } catch (e) { return; }
    if (!cfg || !cfg.type) return;
    var name = box.getAttribute('data-name') || 'this diffuser';
    var fmt = function (n) { return Number(n).toLocaleString('en-US'); };
    var mins = function (m) { m = Math.round(m); return m < 60 ? m + ' minute' + (m === 1 ? '' : 's') : Math.floor(m / 60) + ' hr ' + (m % 60) + ' min'; };
    var render;

    if (cfg.type === 'scent') {
      var PRE = { Soft: { min: 600, t: { s: [7, 180], m: [10, 180], l: [12, 120], x: [15, 100] }, n: 3 },
                  Mild: { min: 600, t: { s: [9, 180], m: [13, 180], l: [15, 140], x: [15, 90] }, n: 4 },
                  Strong: { min: 659, t: { s: [11, 180], m: [15, 180], l: [15, 120], x: [15, 80] }, n: 5 } };
      var SPACE = [['s', 'Small', 'up to 300 ft²', 300], ['m', 'Medium', 'about 500 ft²', 500], ['l', 'Large', 'about 1,000 ft²', 1000], ['x', 'Extra large', '1,500 ft² +', 1500]];
      var ML_MIN = 0.10, ml = +cfg.ml || +cfg.refill || 500, refill = +cfg.refill || ml, price = +cfg.price || 0, cover = +cfg.cover || 0;
      var fixed = cfg.space && SPACE.some(function (x) { return x[0] === cfg.space; }) ? cfg.space : '';
      var space = fixed || (cover >= 1000 ? 'l' : cover >= 500 ? 'm' : 's'), str = 'Mild';
      var art = function (k) { return k === 'x' ? 'an' : 'a'; };
      render = function () {
        var p = PRE[str], w = p.t[space][0], r = p.t[space][1];
        var mlDay = p.min * w / (w + r) * ML_MIN, days = Math.floor(ml / mlDay), month = price ? price / refill * mlDay * 30 : 0;
        var sprays = Math.round(p.min * 60 / (w + r)), rest = r >= 60 ? (r % 60 ? Math.floor(r / 60) + ' min ' + (r % 60) + ' s' : (r / 60) + ' minutes') : r + ' seconds';
        var sp = SPACE.filter(function (x) { return x[0] === space; })[0], unit = ml > 1000 ? 'drum' : 'bottle';
        var tooBig = !fixed && cover && sp[3] > cover;
        box.innerHTML = '<h4>Scent estimator</h4><p>How long one ' + fmt(ml) + ' ml ' + unit + ' lasts ' + (fixed ? 'in ' + art(space) + ' ' + sp[1].toLowerCase() + ' space (' + sp[2] + ')' : 'in your space') + '.</p>' +
          (fixed ? '' : '<div class="est-l">Your space</div><div class="est-o">' + SPACE.map(function (x) { return '<button type="button" class="' + (x[0] === space ? 'on' : '') + '" data-esp="' + x[0] + '">' + x[1] + '<small>' + x[2] + '</small></button>'; }).join('') + '</div>') +
          '<div class="est-l">Scent intensity</div><div class="est-o s3">' + Object.keys(PRE).map(function (k, i) { return '<button type="button" class="' + (k === str ? 'on' : '') + '" data-estr="' + k + '">' + k + '<i>' + '●●●'.slice(0, i + 1) + '○○○'.slice(0, 2 - i) + '</i></button>'; }).join('') + '</div>' +
          '<div class="est-r"><b>About ' + days + ' day' + (days === 1 ? '' : 's') + '</b><span>per ' + fmt(ml) + ' ml ' + unit + ' · about ' + mlDay.toFixed(1) + ' ml a day</span>' + (month ? '<small>About $' + Math.round(month) + ' a month in scent oil</small>' : '') + '</div>' +
          (tooBig ? '<div class="est-w">This space is bigger than the ' + name + ' covers (up to ' + fmt(cover) + ' ft²).</div>' : '') +
          '<div class="est-n">' + str + ' in ' + art(space) + ' ' + sp[1].toLowerCase() + ' space: on about ' + Math.round(p.min / 60) + ' hours a day (' + p.n + ' time blocks), spraying ' + w + ' seconds then resting ' + rest + ', about ' + sprays + ' sprays a day. Same schedules as the One Green Solution app; your own schedule changes the result.</div>';
      };
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-esp],[data-estr]'); if (!b) return;
        if (b.dataset.esp) space = b.dataset.esp; else str = b.dataset.estr;
        render();
      });
    }

    else if (cfg.type === 'water') {
      var GPM = +cfg.gpm || 0.5, OZ_S = GPM * 128 / 60, TANK = (+cfg.tank_gal || 4.2) * 128, cur = 's40';
      var IC = { cup: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h11l-1.2 11a2 2 0 0 1-2 1.8H9.2a2 2 0 0 1-2-1.8z"/><path d="M17 10h1.5a2 2 0 0 1 0 4H16.6"/><path d="M9 3.5c0 1 1 1 1 2M12 3.5c0 1 1 1 1 2"/></svg>',
                 tum: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 6h10l-1.4 14.2a1 1 0 0 1-1 .8H9.4a1 1 0 0 1-1-.8z"/><path d="M6.5 6h11V4.5a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1z"/><path d="M14 3.5V1.8"/><path d="M17 8.5h1.5a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5H16.4"/></svg>',
                 ket: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9h11l1 10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"/><path d="M8 9V7a3.5 3.5 0 0 1 7 0v2"/><path d="M17.5 12l3-2.5"/><path d="M5 17h13"/></svg>' };
      var FLOW = [['cup', 'Cup', '8 oz', 8, '8 oz cup'], ['ket', 'Kettle', '1.7 L', 57.5, '1.7 L electric kettle (57 oz)'], ['s20', 'Stanley', '20 oz', 20, '20 oz Stanley tumbler'], ['s30', 'Stanley', '30 oz', 30, '30 oz Stanley tumbler'], ['s40', 'Stanley', '40 oz', 40, '40 oz Stanley tumbler']];
      var fTime = function (s) { return s < 60 ? Math.round(s) + ' seconds' : Math.floor(s / 60) + ' min ' + Math.round(s % 60) + ' s'; };
      var btn = function (x) { return '<button type="button" class="' + (x[0] === cur ? 'on' : '') + '" data-wflow="' + x[0] + '" aria-label="' + x[4] + '">' + IC[x[0] === 'cup' ? 'cup' : x[0] === 'ket' ? 'ket' : 'tum'] + x[1] + '<small>' + x[2] + '</small></button>'; };
      render = function () {
        var f = FLOW.filter(function (x) { return x[0] === cur; })[0], sec = f[3] / OZ_S, fills = Math.floor(TANK / f[3]);
        box.innerHTML = '<h4>Water flow estimator</h4><p>How fast the Cleone\'s faucet fills it, at ' + GPM + ' gallons a minute.</p>' +
          '<div class="est-l">Fill a</div><div class="flow-o">' + FLOW.slice(0, 2).map(btn).join('') + '</div><div class="flow-o s3">' + FLOW.slice(2).map(btn).join('') + '</div>' +
          '<div class="flow-r"><b>About ' + fTime(sec) + '</b><span>to fill a ' + f[4] + '</span><div class="flow-bar"><i style="animation-duration:' + (Math.min(sec, 60) / 4) + 's"></i></div></div>' +
          '<div class="est-n">A full ' + (+cfg.tank_gal || 4.2) + ' gal tank fills about ' + fills + ' of these, and the Cleone makes up to 50 gallons of pure water a day. Times are at the faucet\'s ' + GPM + ' gpm from a full tank; your water pressure can change them a little.</div>';
      };
      box.addEventListener('click', function (e) { var b = e.target.closest('[data-wflow]'); if (!b) return; cur = b.dataset.wflow; render(); });
    }

    else if (cfg.type === 'air') {
      var speeds = cfg.speeds || [['Low', 90, 12, '39'], ['Medium', 125, 19, '45'], ['High', 175, 33, '49'], ['Turbo', 220, 73, '57']];
      var acover = +cfg.cover || 1200, CEIL = +cfg.ceiling || 8.5, size = Math.min(600, acover), speed = speeds[speeds.length - 1][0];
      var result = function () {
        var sp = speeds.filter(function (x) { return x[0] === speed; })[0], cfm = sp[1], vol = size * CEIL, min = vol / cfm, ach = cfm * 60 / vol;
        return { r: '<b>About ' + mins(min) + '</b><span>to pass all the air in a ' + fmt(size) + ' ft² room through the filters once</span><div class="ca-bar"><i style="animation-duration:' + (Math.min(min, 60) / 12) + 's"></i></div>' +
          '<div class="ca-row"><div><strong>' + ach.toFixed(1) + '</strong><small>air changes an hour</small></div><div><strong>' + cfm + ' CFM</strong><small>airflow</small></div><div><strong>' + sp[2] + ' W</strong><small>power</small></div></div>',
          n: 'Based on an ' + CEIL + ' ft ceiling (' + fmt(vol) + ' ft³ of air) and the rated airflow for each fan speed. Higher ceilings, open doors and furniture change the result.' };
      };
      render = function () {
        var o = result();
        box.innerHTML = '<h4>Clean air estimator</h4><p>How fast it moves all the air in your room through its filters.</p>' +
          '<div class="est-l">Room size</div><div class="ca-range"><span class="ca-size">' + fmt(size) + ' ft²</span><input type="range" min="100" max="' + acover + '" step="50" value="' + size + '" data-casize aria-label="Room size in square feet"><div><span>100 ft²</span><span>' + fmt(acover) + ' ft²</span></div></div>' +
          '<div class="est-l">Fan speed</div><div class="est-o">' + speeds.map(function (s) { return '<button type="button" class="' + (s[0] === speed ? 'on' : '') + '" data-caspeed="' + s[0] + '">' + s[0] + '<small>' + s[3] + ' dB</small></button>'; }).join('') + '</div>' +
          '<div class="ca-r">' + o.r + '</div><div class="est-n">' + o.n + '</div>';
      };
      box.addEventListener('click', function (e) { var b = e.target.closest('[data-caspeed]'); if (!b) return; speed = b.dataset.caspeed; render(); });
      box.addEventListener('input', function (e) { var t = e.target.closest('[data-casize]'); if (!t) return; size = +t.value; var o = result(); box.querySelector('.ca-size').textContent = fmt(size) + ' ft²'; box.querySelector('.ca-r').innerHTML = o.r; box.querySelector('.est-n').textContent = o.n; });
    }

    else if (cfg.type === 'superv') {
      var TONS = [1.5, 2, 2.5, 3, 3.5, 4, 5, 6], PER_TON = +cfg.cfm_per_ton || 400, SCEIL = +cfg.ceiling || 8.5, ton = 3, hsize = 1500, fan = 'auto';
      var model = function (cfm) { return cfm <= 1000 ? ['1700', '1,000 CFM'] : cfm <= 2000 ? ['3400', '2,000 CFM'] : ['5100', '3,000 CFM']; };
      var sres = function () {
        var cfm = ton * PER_TON, vol = hsize * SCEIL, min = vol / cfm, ach = cfm * 60 / vol, duty = fan === 'auto' ? .5 : 1, m = model(cfm);
        return { r: '<b>About every ' + mins(min / duty) + '</b><span>on average, all the air in your ' + fmt(hsize) + ' ft² home passes through the Super V' + (fan === 'auto' ? ' (every ' + mins(min) + ' while the fan is running, about half the time)' : ', with the fan running all the time') + '</span>' +
          '<div class="ca-row"><div><strong>' + (ach * duty).toFixed(1) + '</strong><small>air changes an hour on average</small></div><div><strong>' + m[0] + '</strong><small>recommended model (' + m[1] + ')</small></div><div><strong>' + (fan === 'auto' ? 'Up to 3 yrs' : 'About 1½ yrs') + '</strong><small>filter life</small></div></div>',
          n: 'Estimate uses about ' + PER_TON + ' CFM of airflow per ton of AC and an ' + SCEIL + ' ft ceiling (' + fmt(vol) + ' ft³ of air). Your real airflow depends on your blower and ducts, so we measure it and confirm the right model at your free consultation.' };
      };
      render = function () {
        var o = sres();
        box.innerHTML = '<h4>Whole-home clean air estimator</h4><p>The Super V cleans all the air your AC moves. Pick your AC size and we\'ll fill in a typical home size (500 ft² per ton). You can adjust it.</p>' +
          '<div class="est-l">Your AC size</div><div class="est-o sv-t">' + TONS.map(function (t) { return '<button type="button" class="' + (t === ton ? 'on' : '') + '" data-svton="' + t + '">' + (t === 6 ? '6+' : t) + ' ton<small>' + fmt(t * PER_TON) + ' CFM</small></button>'; }).join('') + '</div>' +
          '<div class="est-l">Home size</div><div class="ca-range"><span class="ca-size">' + fmt(hsize) + ' ft²</span><input type="range" min="600" max="4000" step="50" value="' + hsize + '" data-svsize aria-label="Home size in square feet"><div><span>600 ft²</span><span>4,000 ft²</span></div></div>' +
          '<div class="est-l">AC fan setting</div><div class="est-o s2"><button type="button" class="' + (fan === 'auto' ? 'on' : '') + '" data-svfan="auto">Auto<small>runs about half the time</small></button><button type="button" class="' + (fan === 'on' ? 'on' : '') + '" data-svfan="on">On<small>runs all the time</small></button></div>' +
          '<div class="ca-r">' + o.r + '</div><div class="est-n">' + o.n + '</div>';
      };
      box.addEventListener('click', function (e) { var b = e.target.closest('[data-svton],[data-svfan]'); if (!b) return; if (b.dataset.svton) { ton = +b.dataset.svton; hsize = ton * 500; } else fan = b.dataset.svfan; render(); });
      box.addEventListener('input', function (e) { var t = e.target.closest('[data-svsize]'); if (!t) return; hsize = +t.value; var o = sres(); box.querySelector('.ca-size').textContent = fmt(hsize) + ' ft²'; box.querySelector('.ca-r').innerHTML = o.r; box.querySelector('.est-n').textContent = o.n; });
    }

    if (render) render();
  });

  /* Compare diffusers (collection page): tick 2-3 cards, table under the grid */
  (function () {
    var root = document.querySelector('[data-cmp-root]'), bar = document.querySelector('[data-cmp-bar]');
    if (!root || !bar) return;
    var boxes = Array.prototype.slice.call(document.querySelectorAll('input[data-cmp]'));
    if (!boxes.length) return;
    var tbl = root.querySelector('[data-cmp-table]'), hint = root.querySelector('[data-cmp-hint]'), msg = bar.querySelector('[data-cmp-msg]'), go = bar.querySelector('[data-cmpgo]');
    var esc = function (v) { return String(v || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
    function update() {
      var on = boxes.filter(function (b) { return b.checked; });
      boxes.forEach(function (b) { var off = !b.checked && on.length >= 3; b.disabled = off; b.closest('.s-cmp').classList.toggle('off', off); });
      bar.hidden = on.length === 0;
      msg.textContent = on.length + ' selected' + (on.length < 2 ? ' · pick 1 more' : '');
      go.hidden = on.length < 2; go.textContent = 'Compare ' + on.length + ' ↓';
      if (on.length < 2) { tbl.hidden = true; hint.hidden = false; return; }
      hint.hidden = true; tbl.hidden = false;
      var row = function (label, key) { return '<tr><td>' + label + '</td>' + on.map(function (b) { return '<td>' + esc(b.getAttribute('data-' + key)) + '</td>'; }).join('') + '</tr>'; };
      tbl.innerHTML = '<table style="min-width:' + (120 + on.length * 180) + 'px"><tr><th></th>' + on.map(function (b) {
        return '<th><div class="cmp-th">' + (b.getAttribute('data-img') ? '<img src="' + esc(b.getAttribute('data-img')) + '" alt="" loading="lazy">' : '') + '</div><a href="' + esc(b.getAttribute('data-url')) + '">' + esc(b.getAttribute('data-name')) + '</a> <button type="button" class="cmp-x" data-cmpx="' + esc(b.getAttribute('data-cmp')) + '" aria-label="Remove ' + esc(b.getAttribute('data-name')) + '">✕</button></th>';
      }).join('') + '</tr>' + row('Covers', 'cover') + row('Control', 'control') + row('Power', 'power') + row('Bottle', 'bottle') + row('Placement', 'mount') + row('Colors', 'colors') +
        '<tr><td>Price</td>' + on.map(function (b) { return '<td><b style="font-weight:600">' + esc(b.getAttribute('data-price')) + '</b></td>'; }).join('') + '</tr></table>';
    }
    boxes.forEach(function (b) { b.addEventListener('change', update); });
    bar.querySelector('[data-cmpclear]').addEventListener('click', function () { boxes.forEach(function (b) { b.checked = false; }); update(); });
    go.addEventListener('click', function () { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    tbl.addEventListener('click', function (e) { var x = e.target.closest('[data-cmpx]'); if (!x) return; boxes.forEach(function (b) { if (b.getAttribute('data-cmp') === x.getAttribute('data-cmpx')) b.checked = false; }); update(); });
    update();
  })();

  document.querySelectorAll('[data-fold-btn]').forEach(function (btn) {
    var sec = btn.closest('.ogs-foldable, .ogs-foldgrid'); if (!sec) return;
    btn.addEventListener('click', function () {
      var open = !sec.classList.contains('open');
      sec.classList.toggle('open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.querySelector('[data-open]').hidden = open; btn.querySelector('[data-close]').hidden = !open;
      if (!open) sec.scrollIntoView({ block: 'start', behavior: 'smooth' });
      /* reveal-on-scroll items inside were hidden: show them now */
      sec.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
    });
  });
})();
